import { memo } from "react";
import { Form, FormControlProps } from "react-bootstrap";
import styled from "styled-components";

interface TextInputProps extends FormControlProps {
  hasError?: boolean | undefined;
  placeholder?: string | undefined;
  textarea?: boolean;
  innerRef?: any;
}

const StyledText = styled(Form.Control)<{ $hasError: boolean | undefined }>`
  border-color: ${(props: any) =>
    props.$hasError ? "red !important" : "var(--field-border)"};
  background-color: var(--field-bg) !important;
  border-radius: 0px;

  &:focus {
    border-color: white;
    background-color: var(--field-bg);
    box-shadow: none;
  }
`;

const TextInput = (props: TextInputProps) => {
  const {
    hasError,
    value,
    onChange,
    placeholder = "",
    textarea,
    className,
    name,
    id,
    disabled,
    type,
    spellCheck,
    onKeyUp,
    autoFocus,
    height,
    innerRef,
  } = props;

  return (
    <StyledText
      ref={innerRef}
      spellCheck={spellCheck}
      disabled={disabled}
      height={height}
      id={id}
      name={name}
      className={className}
      as={textarea ? "textarea" : ""}
      placeholder={placeholder}
      $hasError={hasError}
      value={value}
      onChange={onChange}
      type={type}
      onKeyUp={onKeyUp}
      autoFocus={autoFocus}
    />
  );
};

export default memo(TextInput);
